const ClassDescription = Vue.component('cpcinfos', {
    template: `
        <div>
            <div class="row title">
                <h4>
                    {{ $language.cpcClassName.replace('[CLASSNAME]', cpc).replace('[SYSTEM]', system.toUpperCase()) }}
                </h4>
                <a class="snapshotLink" :href="$setupPath + '../classSnapshot/public/?system=' + system.toUpperCase() + '&class=' + encodeURI(cpc)" target="_blank" title="Link to the full snapshot">
                    Snapshot <img :src="$setupPath + 'components/images/logos/analytics/favicon.ico'" alt="snapshot logo">
                </a>
            </div>
            <div class="main" id="cpcInfos">

                <div class="row">
                    <div class="col-md-5">
                        <div class="row summary">
                            <div class="col-12">
                                <div class="row" v-for="(value, field) in cpcData.summary">
                                    <div class="col-8">
                                        <b v-if="field == 'applications'"> {{ $language.appNum }} </b>
                                        <b v-else-if="field == 'families'"> {{ $language.famNum }} </b>
                                        <b v-else-if="field == 'publications'"> {{ $language.pubNum }} </b>
                                    </div>
                                    <div class="col-4">
                                        {{ value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row sectors">
                            <div class="col-12">
                                <div class="row" v-for="(value, field) in cpcData.techareas">
                                    <div class="col-8">
                                        <b>
                                            {{ field }}
                                        </b>
                                    </div>
                                    <div class="col-4">
                                        {{ value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 cpcDescription">
                        <div class="classBorder">
                            <div class="row" v-for="description in cpcData.description">
                                <div class="col-xl-3 col-4" :class="'indent-' + description.indent">
                                    <b>
                                        {{ description.symbol }}
                                    </b>
                                </div>
                                <div class="col-xl-9 col-8"  :class="'dot-' + description.dots">
                                    {{ description.text }}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div id="assigneesChart"></div>
                    </div>
                    <div class="col-md-6">
                        <div id="juridisctionsChart"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div id="yearsChart"></div>
                    </div>
                </div>
            </div>
        </div>
    `,

    data: function() {
        return {
            cpcData: {}
        };
    },

    watch: {
        cpc: function(newcpc, oldcpc) {
            this.onNewCpc();
        }
    },

    computed: {
        cpc: function() {
            return this.$route.params.class;
        },
        family() {
            return this.$route.params.family;
        },
        system() {
            return this.$route.params.system;
        }
    },

    mounted: function() {

        this.onNewCpc();

    },

    methods: {

        onNewCpc() {
            this.$store.commit('changeLoadedCpc', this.cpc);

            if (!this.$store.state.cpcInfos[this.cpc]) {

                axios.get('?page=getData&action=classData', {
                        params: {
                            class: this.cpc,
                            system: this.system
                        }
                    })
                    .then(response => {

                        this.cpcData = response.data;
                        this.$store.commit('storeCpcInfos', {
                            cpc: this.cpc,
                            data: response.data,
                            system: this.system
                        })
                        this.drawChart()
                    })
                    .catch(err => {
                        console.log(err);
                    })
            } else {
                this.cpcData = this.$store.state.cpcInfos[this.cpc];
                this.drawChart()
            }
        },

        drawChart: function() {

            Highcharts.setOptions({
                colors: ['#afd8f8', '#f6bd10', '#8cbb02', '#ff8f48', '#028f8f', '#d64848', '#8f488f', '#5a8629', '#b4ab03', '#038fd6', '#9e0b10', '#a287bf', '#cd6904', '#fdc78b', '#ada205', '#f2707f', '#fff205', '#0558a8', '#f79721', '#cd3805']
            });

            //make the assignees data usable in highcharts
            var assigneesData = [];
            var assignees = [];

            this.cpcData.assignees.forEach(function(assignee) {
                assigneesData.push({
                    y: assignee.total,
                    name: assignee.assignee
                });
                assignees.push(assignee.assignee);
            });

            Highcharts.chart('assigneesChart', {
                chart: {
                    type: 'bar',
                    renderTo: 'container'
                },

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },

                title: {
                    text: this.$language.topAssignees,
                    useHTML: true
                },

                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                xAxis: {
                    title: {
                        text: this.$language.assignees
                    },
                    ceiling: 4,
                    categories: assignees,

                },

                yAxis: {
                    allowDecimals: false,
                    min: 0,
                    title: {
                        text: this.$language.applications,
                        align: 'high'
                    },

                    labels: {
                        overflow: 'justify'
                    }
                },

                navigation: {
                    buttonOptions: {
                        enabled: true
                    }
                },

                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            allowOverlap: true

                        }
                    }
                },

                legend: {
                    enabled: false

                },

                credits: {
                    enabled: false
                },

                series: [{
                    name: this.$language.assignees,
                    colorByPoint: true,
                    data: assigneesData
                }]
            });

            //make the jurisdictions data usable in highcharts
            var jurisdictionData = [];
            var jurisdictions = [];

            this.cpcData.jurisdictions.forEach(function(jurisdiction) {
                jurisdictionData.push({
                    code: jurisdiction.jurisdiction,
                    y: jurisdiction.total,
                    name: countries.codes[jurisdiction.jurisdiction]
                });
                jurisdictions.push(countries.codes[jurisdiction.jurisdiction] + ' (' + jurisdiction.jurisdiction + ')');
            });

            Highcharts.chart('juridisctionsChart', {
                chart: {
                    type: 'column'
                },

                title: {
                    text: this.$language.topJuris,
                    useHTML: true
                },

                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                navigation: {
                    buttonOptions: {
                        enabled: true
                    }
                },

                xAxis: {
                    crosshair: true,
                    ceiling: 4,
                    categories: jurisdictions
                },

                legend: {
                    enabled: false
                },

                yAxis: {
                    allowDecimals: false,
                    min: 0,
                    title: {
                        text: this.$language.applications
                    }
                },

                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },

                credits: {
                    enabled: false
                },

                series: [{
                    name: '{point.name}',
                    colorByPoint: true,
                    data: jurisdictionData,
                    tooltip: {
                        pointFormat: this.$language.applications + ': {point.y}'
                    }
                }],

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },

            });

            //make the year data usable in highcharts
            var applicationsData = [];
            var grantsData = [];
            var start = [];

            for (var year in this.cpcData.years) {
                if (this.cpcData.years.hasOwnProperty(year)) {
                    start.push(year);
                    applicationsData.push([year, this.cpcData.years[year].applications]);
                    grantsData.push([year, this.cpcData.years[year].grants]);
                }
            }

            Highcharts.chart('yearsChart', {
                chart: {
                    type: 'spline'
                },

                title: {
                    text: this.$language.appNGrant,
                    useHTML: true
                },

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },

                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                navigation: {
                    buttonOptions: {
                        enabled: true
                    }
                },

                yAxis: {
                    allowDecimals: false,
                    title: {
                        text: this.$language.appNGrant
                    }
                },

                plotOptions: {
                    series: {
                        pointStart: parseInt(start[0])
                    }
                },

                legend: {
                    enabled: false
                },

                credits: {
                    enabled: false
                },

                series: [{
                    name: this.$language.applications,
                    data: applicationsData

                }, {
                    name: this.$language.grants,
                    data: grantsData
                }]
            });

            this.$store.commit('hideLoading');
        }

    }

});
